var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getContentURL } from "../ContentAPI";
import { loadChannelData, } from "../util/DataUtils";
export const getChannelData = (channelOwnerId, channelId, auth, cacheBusterStore, logger) => {
    return new Promise((resolve, reject) => {
        try {
            const callbacks = {
                okCallback: (clientDetailCode, data) => {
                    try {
                        const dataObj = JSON.parse(data);
                        const title = dataObj.title;
                        const description = dataObj.description;
                        const imageUrl = getContentURL() +
                            "/u/" +
                            channelOwnerId +
                            "/" +
                            channelId +
                            "/" +
                            "channelImage_512.jpg";
                        // TODO: check image
                        const channelData = {
                            channelOwnerId: channelOwnerId,
                            channelId: channelId,
                            title,
                            description,
                            imageUrl,
                        };
                        resolve(channelData);
                    }
                    catch (err) {
                        reject(err);
                    }
                },
                errorCallback: (clientDetailCode, errorMessage) => {
                    reject(new Error("Unable to load channel data. " +
                        clientDetailCode +
                        " " +
                        errorMessage));
                },
            };
            loadChannelData("u", channelOwnerId, channelId, "channelData", "json", callbacks, auth, cacheBusterStore, logger);
        }
        catch (err) {
            console.error("Unable to get channel data. " + err);
            reject(err);
        }
    });
};
export const setLastChannelImageUrl = (url) => {
    localStorage.setItem("lastChannelImageUrl", url);
};
export const getLastChannelImageUrl = () => {
    try {
        const retVal = localStorage.getItem("lastChannelImageUrl");
        if (retVal) {
            return retVal;
        }
        else {
            return undefined;
        }
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
};
const RECENT_CHANNELS_KEY = "recentChannels";
const MAX_RECENT_CHANNELS = 4;
export const addRecentChannel = (channelOwnerId, channelId, title, imageUrl) => {
    try {
        const recentChannels = getRecentChannels();
        // Create new recent channel entry
        const newRecentChannel = {
            channelOwnerId,
            channelId,
            title,
            imageUrl,
            visitedAt: Date.now(),
        };
        // Remove existing entry for this channel if it exists
        const filteredChannels = recentChannels.filter((channel) => !(channel.channelOwnerId === channelOwnerId &&
            channel.channelId === channelId));
        // Add new entry at the beginning
        const updatedChannels = [newRecentChannel, ...filteredChannels];
        // Keep only the most recent MAX_RECENT_CHANNELS
        const trimmedChannels = updatedChannels.slice(0, MAX_RECENT_CHANNELS);
        localStorage.setItem(RECENT_CHANNELS_KEY, JSON.stringify(trimmedChannels));
    }
    catch (err) {
        console.error("Error adding recent channel:", err);
    }
};
export const getRecentChannels = () => {
    try {
        const stored = localStorage.getItem(RECENT_CHANNELS_KEY);
        if (stored) {
            const channels = JSON.parse(stored);
            // Sort by visitedAt descending to ensure most recent first
            return channels.sort((a, b) => b.visitedAt - a.visitedAt);
        }
        return [];
    }
    catch (err) {
        console.error("Error getting recent channels:", err);
        return [];
    }
};
export const removeRecentChannel = (channelOwnerId, channelId) => {
    try {
        const recentChannels = getRecentChannels();
        // Filter out the channel to be removed
        const filteredChannels = recentChannels.filter((channel) => !(channel.channelOwnerId === channelOwnerId &&
            channel.channelId === channelId));
        // Update localStorage with the filtered list
        localStorage.setItem(RECENT_CHANNELS_KEY, JSON.stringify(filteredChannels));
        console.log(`Removed recent channel: ${channelOwnerId}/${channelId}. ` +
            `Remaining channels: ${filteredChannels.length}`);
    }
    catch (err) {
        console.error("Error removing recent channel:", err);
    }
};
export const clearRecentChannels = () => {
    try {
        localStorage.removeItem(RECENT_CHANNELS_KEY);
    }
    catch (err) {
        console.error("Error clearing recent channels:", err);
    }
};
export const listChannelsUserCanPost = (auth, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
    // TODO: Implement method to fetch channels user can post to
    // This should return channels the user owns plus channels they have posting permissions for
    logger.log("ChannelStore: listChannelsUserCanPost - TODO: Implementation needed");
    if (!auth || !auth.userId || !auth.displayName) {
        return [];
    }
    const feedChannel = {
        channelOwnerId: auth.userId,
        channelId: auth.userId,
        title: auth.displayName + "'s Feed",
    };
    return [feedChannel];
});
export const loadTopRecentChannelImage = (callbacks, auth, cacheBusterStore, logger) => {
    logger.log("ChannelStore: loadTopRecentChannelImage");
    try {
        const recentChannels = getRecentChannels();
        if (recentChannels.length === 0) {
            logger.log("ChannelStore: No recent channels found, using fallback");
            callbacks.okCallback(undefined);
            return;
        }
        // Function to check channels recursively until we find one with an image
        const checkChannelForImage = (channelIndex) => {
            if (channelIndex >= recentChannels.length) {
                logger.log("ChannelStore: No recent channels with images found, using fallback");
                callbacks.okCallback(undefined);
                return;
            }
            const channel = recentChannels[channelIndex];
            logger.log(`ChannelStore: Checking recent channel ${channelIndex}: ${channel.channelOwnerId}/${channel.channelId}`);
            // Construct the channel image URL
            const imageUrl = getContentURL() +
                "/u/" +
                channel.channelOwnerId +
                "/" +
                channel.channelId +
                "/channelImage_512.jpg";
            // For channels, we'll assume they have images and return the URL
            // The ContentCard component will handle fallback if the image fails to load
            logger.log(`ChannelStore: Found recent channel image at index ${channelIndex}, imageUrl = ${imageUrl}`);
            callbacks.okCallback(imageUrl);
        };
        // Start checking from the first (most recent) channel
        checkChannelForImage(0);
    }
    catch (err) {
        logger.error("ChannelStore: Error loading top recent channel image: " + err);
        callbacks.errorCallback(err.message);
    }
};
